"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setWorkspaces = exports.getWorkspaces = exports.selectAllWorkspaces = exports.workspaceSliceConfig = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var firestore_1 = require("firebase/firestore");
var firestore_2 = require("firebase/firestore");
var lodash_1 = __importDefault(require("lodash"));
var firestore;
var workspaceSliceConfig = function (_firebaseApp) {
    // eslint-disable-next-line
    firestore = (0, firestore_2.getFirestore)(_firebaseApp);
};
exports.workspaceSliceConfig = workspaceSliceConfig;
var initialState = {
    initialised: false,
    workspaces: [],
};
var workspaceSlice = (0, toolkit_1.createSlice)({
    name: 'workspace',
    initialState: initialState,
    reducers: {
        setWorkspaces: {
            reducer: function (state, action) {
                if (action.payload) {
                    state.initialised = true;
                    state.workspaces = action.payload;
                }
            },
            prepare: function (payload) {
                if (payload) {
                    var workspacesModels = payload.map(function (workspace) {
                        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
                        return {
                            id: (_a = workspace.id) !== null && _a !== void 0 ? _a : '',
                            name: (_b = workspace.name) !== null && _b !== void 0 ? _b : '',
                            companyLogo: (_c = workspace.companyLogo) !== null && _c !== void 0 ? _c : '',
                            inviteCode: (_d = workspace.inviteCode) !== null && _d !== void 0 ? _d : '',
                            createdAt: workspace.createdAt instanceof firestore_1.Timestamp ? (_f = (_e = workspace.createdAt) === null || _e === void 0 ? void 0 : _e.toDate().toISOString()) !== null && _f !== void 0 ? _f : '' : '',
                            createdBy: (_g = workspace.createdBy) !== null && _g !== void 0 ? _g : '',
                            usersCount: (_h = workspace.usersCount) !== null && _h !== void 0 ? _h : 0,
                            industry: (_j = workspace.industry) !== null && _j !== void 0 ? _j : '',
                            companySize: (_k = workspace.companySize) !== null && _k !== void 0 ? _k : '',
                            packageId: (_l = workspace.packageId) !== null && _l !== void 0 ? _l : '',
                            repoStorageSize: (_m = workspace.repoStorageSize) !== null && _m !== void 0 ? _m : 0,
                            knowledgeStorageSize: (_o = workspace.knowledgeStorageSize) !== null && _o !== void 0 ? _o : 0,
                        };
                    });
                    return { payload: workspacesModels };
                }
                return { payload: null };
            },
        },
    },
    extraReducers: function (builder) {
        builder.addCase('workspace/setWorkspaces', function (state, action) {
            console.log('workspace/setWorkspaces/fulfilled', { state: state, action: action });
        });
    },
});
// Selectors
var selectAllWorkspaces = function (state) { return state.workspace.workspaces; };
exports.selectAllWorkspaces = selectAllWorkspaces;
exports.getWorkspaces = (0, toolkit_1.createSelector)([exports.selectAllWorkspaces], function (workspaces) {
    return lodash_1.default.orderBy(workspaces, [function (ws) { return ws.name.toLowerCase(); }], ['asc']);
});
// Actions
exports.setWorkspaces = workspaceSlice.actions.setWorkspaces;
exports.default = workspaceSlice.reducer;
